"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mountIsland_1 = require("../../mountIsland");
var Link_1 = __importDefault(require("@mui/material/Link"));
var Lang_js_1 = require("../../Lang.js");
// Import components
var InternalNav_jsx_1 = __importDefault(require("../common/InternalNav.jsx"));
var GroupCard_jsx_1 = __importDefault(require("../common/GroupCard.jsx"));
var InfiniteScrollContainer_1 = __importDefault(require("../common/InfiniteScrollContainer"));
var GroupsGrid = function (_a) {
    var _b;
    var groupResponse = _a.groupResponse;
    var _c = (0, react_1.useState)([]), groupItems = _c[0], setGroupItems = _c[1];
    var _d = (0, react_1.useState)(true), loading = _d[0], setLoading = _d[1];
    var _e = (0, react_1.useState)(1), page = _e[0], setPage = _e[1];
    var _f = (0, react_1.useState)(true), hasMore = _f[0], setHasMore = _f[1];
    var _g = (0, react_1.useState)(10), perPage = _g[0], setPerPage = _g[1];
    var _h = (0, react_1.useState)({}), filters = _h[0], setFilters = _h[1];
    var _j = (0, react_1.useState)(null), title = _j[0], setTitle = _j[1];
    var fetchGroups = (0, react_1.useCallback)(function (pageNum, _a) {
        var _b = _a === void 0 ? {} : _a, filtersOverride = _b.filters, perPageOverride = _b.perPage;
        return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, params_1, activePerPage, activeFilters, response, data, newGroupItems_1, currentPage, totalPages, error_1;
            var _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        baseUrl = ((_c = groupResponse === null || groupResponse === void 0 ? void 0 : groupResponse.permalinks) === null || _c === void 0 ? void 0 : _c.api) || String(location.origin + location.pathname).replace('/app/', '/api/v2/');
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 4, 5, 6]);
                        params_1 = new URLSearchParams();
                        params_1.set('page', String(pageNum));
                        activePerPage = perPageOverride !== null && perPageOverride !== void 0 ? perPageOverride : perPage;
                        if (activePerPage) {
                            params_1.set('per_page', String(activePerPage));
                        }
                        activeFilters = filtersOverride !== null && filtersOverride !== void 0 ? filtersOverride : filters;
                        Object.entries(activeFilters).forEach(function (_a) {
                            var key = _a[0], value = _a[1];
                            if (value === undefined || value === null) {
                                return;
                            }
                            if (Array.isArray(value)) {
                                if (value.length === 0) {
                                    return;
                                }
                                value.forEach(function (item) { return params_1.append("".concat(key, "[]"), item); });
                                return;
                            }
                            if (value !== '') {
                                params_1.set(key, String(value));
                            }
                        });
                        return [4 /*yield*/, fetch(baseUrl + '?' + params_1.toString())];
                    case 2:
                        response = _g.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _g.sent();
                        newGroupItems_1 = data.group || [];
                        setGroupItems(function (prev) { return prev.concat(newGroupItems_1); });
                        if (data.pagination) {
                            currentPage = data.pagination.page ? parseInt(data.pagination.page) : pageNum;
                            totalPages = (_d = data.pagination.total_pages) !== null && _d !== void 0 ? _d : 1;
                            setPage(currentPage);
                            setPerPage((_f = (_e = data.pagination.per_page) !== null && _e !== void 0 ? _e : activePerPage) !== null && _f !== void 0 ? _f : perPage);
                            setHasMore(currentPage < totalPages);
                        }
                        else {
                            setPage(pageNum);
                            setHasMore(groupItems.length > 0);
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _g.sent();
                        console.error('Error fetching groups:', error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }, [filters, perPage, groupResponse]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (!groupResponse) {
            setLoading(false);
            return;
        }
        var container = document.getElementById('groups-index');
        // get groups from data-groups attribute
        setTitle(container.getAttribute('data-title') || (0, Lang_js_1.__)('Groups'));
        var initialGroupItems = groupResponse.group;
        var initialPagination = groupResponse.pagination || {};
        var initialFilters = groupResponse.filters || {};
        setGroupItems(initialGroupItems);
        setFilters(initialFilters);
        var derivedPerPage = (_a = initialPagination.per_page) !== null && _a !== void 0 ? _a : (initialGroupItems.length > 0 ? initialGroupItems.length : 10);
        setPerPage(derivedPerPage);
        var currentPage = (_b = initialPagination.page) !== null && _b !== void 0 ? _b : 1;
        var totalPages = (_c = initialPagination.total_pages) !== null && _c !== void 0 ? _c : (initialGroupItems.length > 0 ? currentPage : 1);
        setPage(currentPage);
        setHasMore(currentPage < totalPages);
        setLoading(false);
    }, [groupResponse]);
    var loadMore = (0, react_1.useCallback)(function () {
        if (loading || !hasMore)
            return;
        // use current page to request the next one
        fetchGroups(page + 1);
    }, [loading, hasMore, page, fetchGroups, (_b = groupResponse.permalinks) === null || _b === void 0 ? void 0 : _b.api]);
    var handleDeleteGroup = (0, react_1.useCallback)(function (uniqid) {
        setGroupItems(function (prev) { return prev.filter(function (g) { return g.uniqid !== uniqid; }); });
    }, []);
    return (react_1.default.createElement("div", { className: "results-page" },
        react_1.default.createElement("div", { className: "results-header-container" },
            react_1.default.createElement("div", { className: "results-header-inner" },
                react_1.default.createElement("div", { className: "results-header-top-row" },
                    react_1.default.createElement("div", { className: "results-breadcrumb" },
                        react_1.default.createElement(Link_1.default, { href: "/app/twi", className: "video-breadcrumb-link", color: "inherit", underline: "hover" },
                            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", style: { marginRight: '6px', verticalAlign: 'middle' } },
                                react_1.default.createElement("polyline", { points: "15 18 9 12 15 6" })),
                            (0, Lang_js_1.__)('Back to TWI'))),
                    react_1.default.createElement("div", { className: "hero__sidebar" },
                        react_1.default.createElement(InternalNav_jsx_1.default, { isLoggedIn: true }))),
                react_1.default.createElement("div", { className: "results-title-wrapper" },
                    react_1.default.createElement("h1", { className: "results-page-title" }, title !== null && title !== void 0 ? title : (0, Lang_js_1.__)('Groups')),
                    react_1.default.createElement("hr", { className: "results-divider" })))),
        react_1.default.createElement("div", { className: "results-main-section" },
            react_1.default.createElement("div", { className: "group-grid-container" },
                groupItems.length > 0 && (react_1.default.createElement(InfiniteScrollContainer_1.default, { dataLength: groupItems.length, hasMore: hasMore, loadMore: loadMore },
                    react_1.default.createElement("div", { className: "video-grid" }, groupItems.map(function (group, index) {
                        var _a;
                        var key = "".concat((_a = group.uniqid) !== null && _a !== void 0 ? _a : index, "-").concat(index);
                        return (react_1.default.createElement("div", { key: key, className: "video-grid__item" },
                            react_1.default.createElement(GroupCard_jsx_1.default, { group: group, onDelete: handleDeleteGroup })));
                    })))),
                loading && react_1.default.createElement("p", null, (0, Lang_js_1.__)('Loading...')),
                !loading && groupItems.length === 0 && (react_1.default.createElement("div", { className: "no-results" }, (0, Lang_js_1.__)('No groups found.')))))));
};
// Mount component
var groupsContainer = document.getElementById('groups-index');
if (groupsContainer) {
    var groupResponse = JSON.parse(groupsContainer.getAttribute('data-groupResponse') || 'null');
    (0, mountIsland_1.mountIsland)(groupsContainer, react_1.default.createElement(GroupsGrid, { groupResponse: groupResponse }));
}
